import { takeLatest } from 'redux-saga/effects';
import { load } from 'sdk/fspFraudTrans';
import { LOAD } from 'model/fspFraudTrans';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeLatest(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
